import type { QueryClient } from "@tanstack/react-query";

import { chartKeys } from "@/features/dashboard/utils/query-keys.ts";
import { measurementKeys } from "@/features/measurements/utils/query-keys.ts";

export const stageKeys = {
	list: (constructionId: string | undefined) =>
		["stages", constructionId] as const,
	detail: (constructionId: string | undefined, stageId: string | undefined) =>
		["stage", constructionId, stageId] as const,
};

export function invalidateStageTree(
	queryClient: QueryClient,
	constructionId: string | undefined,
) {
	return Promise.all([
		queryClient.invalidateQueries({ queryKey: stageKeys.list(constructionId) }),
		queryClient.invalidateQueries({
			queryKey: measurementKeys.latest(constructionId),
		}),
		queryClient.invalidateQueries({
			queryKey: measurementKeys.histories(constructionId),
		}),
		queryClient.invalidateQueries({
			queryKey: chartKeys.construction(constructionId),
		}),
		queryClient.invalidateQueries({ queryKey: chartKeys.portfolios() }),
	]);
}
